import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoints } from './endpoints';
import { FavouriteAdminListWire } from './types';
import { FavouriteSearchModel } from './types-store';

export const api = {

  loadList: async (
    model: FavouriteSearchModel, startIndex: number, maxResults: number
  ): Promise<FavouriteAdminListWire> => {

    const response = await new RemoteAdminData(endpoints.searchFavourites)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  },

  deleteFavourite: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteFavourite)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  changeOwner: async (owner: number, applyOnDescendants: boolean, data: FavouriteSearchModel) => {
    const request = await new RemoteAdminData(endpoints.changeOwner)
      .resource<ApiResponse<any>>()
      .filter({ owner, applyOnDescendants })
      .create(data);

    return request.data;
  },

  changeUserGroups: async (replace: number, id: number[], applyOnDescendants: boolean, data: FavouriteSearchModel) => {
    const request = await new RemoteAdminData(endpoints.changeUserGroups)
      .resource<ApiResponse<any>>()
      .filter({
        replace: !!replace,
        id: id ?? null,
        applyOnDescendants
      })
      .create(data);

    return request.data;
  },

  changeUsers: async (replace: number, id: number[], applyOnDescendants: boolean, data: FavouriteSearchModel) => {
    const request = await new RemoteAdminData(endpoints.changeUsers)
      .resource<ApiResponse<any>>()
      .filter({
        replace: !!replace,
        id: id ?? null,
        applyOnDescendants
      })
      .create(data);

    return request.data;
  }
};
